export function datepicker() {
    $(".datepicker").datepicker({
        dateFormat:"d M",
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/datepicker.js